import { AuthType } from './types';
import { UserManager } from 'oidc-client-ts';
import { cognitoAuthConfig } from './cognito/cogitoAuthConfig';
import { oidcUserManager } from './oidc/userManager';
import { resolveRuntimeEnvironment } from '../../utils/runtimeEnvironment';

export const getAuthToken = async (): Promise<string | undefined> => {
  const authType: AuthType = import.meta.env.VITE_API_AUTH_STRATEGY;

  switch (authType) {
    case 'cognito': {
      return getCognitoToken();
    }
    case 'oidc-federated': {
      return getOidcToken();
    }
    case 'local':
    case 'cn': {
      return getLocalToken();
    }
    default: {
      const type: never = authType;
      throw new Error(`Unsupported auth type found in getAuthToken: ${type}`);
    }
  }
};

export async function getCognitoToken(): Promise<string | undefined> {
  const users = await new UserManager(cognitoAuthConfig).getUser();
  return users?.access_token;
}

export async function getOidcToken(): Promise<string | undefined> {
  const user = await oidcUserManager.getUser();
  // IdPs that carry email/aud only in the ID token (e.g. Cognito) set VITE_OIDC_TOKEN_TYPE='id';
  // others (whose access token is a verifiable JWT, e.g. Ory Hydra) keep the access-token default.
  // Resolved through resolveRuntimeEnvironment, never compared to 'id' directly: that comparison is between
  // two build-time constants, so the bundler folds it and drops the sentinel the entrypoint rewrites.
  const tokenType = resolveRuntimeEnvironment(import.meta.env.VITE_OIDC_TOKEN_TYPE, 'access');
  return tokenType === 'id' ? user?.id_token : user?.access_token;
}

export function getLocalToken(): string | undefined {
  return localStorage.getItem('authToken') ?? undefined;
}
